import React from 'react';
import { Grid, Typography } from '@mui/material';
import Section from '../../../shared/Section/Section';
import VideoBlock from '../../../shared/VideoBlock/VideoBlock';
import styles from './styles';

function Description({ title, subtitle, data }) {
  return (
    <Section
      subtitle={subtitle}
      title={title}
      theme="dark"
      anchor="about"
      withoutBg
    >
      <Grid container sx={styles.container}>
        <Grid item xs={12} xl={6}>
          <Typography variant="desktopH3" sx={styles.title}>
            {data.title}
          </Typography>
          <Typography variant="desktopP2" sx={styles.note}>
            {data.subtitle}
          </Typography>
        </Grid>
        <Grid item xs={12} xl={6} sx={styles.videoWrapper}>
          <VideoBlock {...data} style="white" />
        </Grid>
      </Grid>
    </Section>
  );
}

export default Description;
